var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shipping-chart"},[_c('div',{staticClass:"chart ml-auto mr-auto mt-4"},[_c('canvas',{staticClass:"canvas-doughnut",attrs:{"id":'dashboard-pie-chart-' + _vm.id}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }